export const snakeCase = string =>
  string
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s\W]+/g, '_')
    .toLowerCase();
